<template>
  <q-layout view="lHh Lpr lFf">
    <q-header elevated>
      <q-toolbar class="bg-mylhs-toolbar">
        <q-btn
          flat
          dense
          round
          icon="menu"
          aria-label="Menu"
          @click="toggleLeftDrawer"
        />

        <q-toolbar-title> Leyden myLHS </q-toolbar-title>
        <client-only>
          <SystemNetworkStatusBadge only-when-offline />
        </client-only>
        <q-btn
          v-if="auth.isAuthenticated === true"
          flat
          dense
          round
          icon="settings"
          aria-label="Settings"
        >
        <q-menu>
          <q-list separator style="min-width: 100px">
            <q-item
              v-if="auth.user.hasRole('tech')"
              v-close-popup
              :to="{ name: 'settings' }"
              clickable
            >
              <q-item-section avatar>
                <q-icon name="settings" />
              </q-item-section>
              <q-item-section>Settings</q-item-section>
            </q-item>
            <q-item
              v-close-popup
              :to="{ name: 'auth-logout' }"
              clickable
              class="text-negative"
            >
              <q-item-section avatar>
                <q-icon :name="`fas fa-door-closed`" />
              </q-item-section>
              <q-item-section>Sign Out</q-item-section>
            </q-item>
          </q-list>
        </q-menu>
      </q-btn>
      </q-toolbar>
      <SystemOutdatedAlert />
    </q-header>

    <SystemMenuLeftMenu v-model="leftDrawerOpen" />

    <q-page-container>
      <slot />
    </q-page-container>
  </q-layout>
</template>

<script setup>
    const leftDrawerOpen = ref(false);
    const toggleLeftDrawer = () => {
      leftDrawerOpen.value = !leftDrawerOpen.value;
    };
    //const { isAuthenticated } = useAuthStore();
    const auth = useAuthStore();
</script>
